export default "__VITE_ASSET__CYbEpiq5__"